import React from "react";
import { motion, useReducedMotion } from "framer-motion";
const questions = ["¿Cuánto me cuesta fabricarlo?", "¿Dónde consigo los insumos?", "¿Cómo calculo el precio?", "¿Cómo presento el producto?", "¿Cómo creo una etiqueta?"];
const enterEase = [0.22, 1, 0.36, 1] as const;
export function EntrepreneurBridge() {
  const reduceMotion = useReducedMotion();
  return <section className="border-y border-[#dce4ed] bg-[#f6f8fb] py-16 sm:py-24" style={{
    paddingTop: "27px",
    paddingBottom: "22px"
  }} data-id="element-47" data-mp="59gfzvucp9gf">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-48" data-mp="9u0ffr1vh4g">
        <motion.div className="text-center" initial={reduceMotion ? false : {
        opacity: 0,
        y: 8
      }} whileInView={reduceMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.45,
        ease: enterEase
      }} data-id="element-49" data-mp="ea4tmpfu17ss">
          <p className="text-[11px] font-bold tracking-[0.15em] text-[#0077e8]" data-id="element-50" data-mp="2c0o6qa18lgqo">DE FABRICAR A EMPRENDER</p>
          <h2 className="mt-4 text-[clamp(1.9rem,8.5vw,2.25rem)] font-extrabold leading-[1.02] tracking-[-0.06em] text-[#091a37] sm:text-4xl" data-id="element-51" data-mp="3tgq597773b3">
            <span className="block" data-id="element-52" data-mp="8s1thhhqy33r">FABRICAR ES SOLO</span>
            <span className="block" data-id="element-53" data-mp="dqlg7k45zix6">EL <span className="text-[#0077e8]" data-id="element-54" data-mp="dpacfkapyb62">PRIMER PASO</span>.</span>
          </h2>
        </motion.div>

        <motion.p className="mx-auto mt-6 max-w-2xl text-center text-lg font-bold leading-[1.28] tracking-[-0.025em] text-[#263754] sm:text-xl" initial={reduceMotion ? false : {
        opacity: 0
      }} whileInView={reduceMotion ? undefined : {
        opacity: 1
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.4,
        delay: 0.12,
        ease: enterEase
      }} data-id="element-55" data-mp="iiwcmczp4mkz">
          Para vender, también necesitás saber cuánto te cuesta, dónde comprar los insumos y cómo presentar tu producto.
        </motion.p>
        <motion.p className="mt-5 text-center text-sm font-bold text-[#0077e8] sm:text-base" initial={reduceMotion ? false : {
        opacity: 0
      }} whileInView={reduceMotion ? undefined : {
        opacity: 1
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.4,
        delay: 0.2,
        ease: enterEase
      }} data-id="element-56" data-mp="337amimv7wukz">
          Ahí es donde Fórmula Emprendedora va más allá de las fórmulas.
        </motion.p>

        <div className="mt-10 text-left sm:mt-12" data-id="element-57" data-mp="304wdqsguel9f">
          <p className="text-[10px] font-extrabold tracking-[0.14em] text-[#657189]" data-id="element-58" data-mp="3e5gw5niuif2e">PARA EMPEZAR A VENDER, APARECEN NUEVAS PREGUNTAS</p>
          <ol className="mt-4 border-y border-[#dce4ed]" data-id="element-59" data-mp="3a3vpijwwmx0n">
            {questions.map((question, index) => <motion.li key={question} className="grid grid-cols-[28px_1fr] gap-3 border-b border-[#dce4ed] py-4 last:border-b-0" initial={reduceMotion ? false : {
            opacity: 0,
            x: -6
          }} whileInView={reduceMotion ? undefined : {
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            amount: 0.25
          }} transition={{
            duration: 0.4,
            delay: 0.28 + index * 0.08,
            ease: enterEase
          }} data-id="element-60" data-mp="3nuh25qvrmaq3" data-mpi={index}>
                <span className="pt-0.5 text-[11px] font-bold text-[#0077e8]" data-id="element-61" data-mp="kbuiwdw3t2jt">0{index + 1}</span>
                <span className="text-[15px] font-bold leading-6 text-[#263754] sm:text-base" data-id="element-62" data-mp="6c1p29pa667m">{question}</span>
              </motion.li>)}
          </ol>
        </div>
      </div>
    </section>;
}